import { useSelector } from "react-redux";

import { ComponentSurvey } from "@components";
import { selectAuth } from "@redux";

export const PageSurvey = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentSurvey
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
